export class SamplePlateHistoryDTO {
    plateId: string;
    position: string;
    approved: boolean;
    sampleId: string;
    id: any;
}